import React from 'react'
import { useTranslation } from 'react-i18next'
import useAppSelector from '../../hooks/useAppSelector'
import { getUpdatesOursSelector } from '../../features/data/dataSlice'
import { CheckinEntryExport } from '../../app/types'
import { Column } from '@material-table/core'
import { ExportCsv } from '@material-table/exporters'
import { CloudDownload } from '@mui/icons-material'
import { Button, Tooltip, Typography } from '@mui/material'
import { useEventId } from '../../app/location'
import useEventTimezone from '../../hooks/useEventTimezone'
import { useStyles } from '../../hooks/useStyles'
import moment from 'moment-timezone'
import { getUsernameSelector } from '../../features/session/sessionSlice'

const ExportModifiedEntries = () => {
  const { classes } = useStyles()
  const eventId = useEventId()
  const eventTimezone = useEventTimezone()
  const username = useAppSelector(getUsernameSelector)
  const { t } = useTranslation()
  const updates = useAppSelector(getUpdatesOursSelector)

  const modifiedEntries: CheckinEntryExport[] = updates.map(u => ({
    reg_choice_name: u.regChoiceName,
    entry_id: u.entryId,
    check_in: u.checkedIn ? 1 : 0,
    mtime: moment(
      (u.checkInTime ? +u.checkInTime! : +u.lastModifiedTime) * 1000
    ).tz(eventTimezone!)?.format('MM/DD/YYYY HH:mm:ss'),
    bib: u.bib,
  })) || []

  const columns: Array<Column<CheckinEntryExport>> = [
    { title: t('Reg Choice'), field: 'reg_choice_name' },
    { title: t('Chrono ID'), field: 'entry_id' },
    { title: t('Checkin Status'), field: 'check_in' },
    { title: t('Last Modified Time'), field: 'mtime' },
    { title: t('Bib'), field: 'bib' }
  ]

  const isButtonDisabled = !modifiedEntries.length

  const generateExportFileName = () => {
    const eventDate = moment.tz(new Date(), eventTimezone!)
    return `modified_athletes-${eventId}-${username}-${eventDate.format('YYYY-MM-DDTHH:mm:ss')}`
  }

  const handleExportClick = () => {
    ExportCsv(columns, modifiedEntries, generateExportFileName())
  }

  const exportButton = (
    <Button
      data-cy='export-checkin-entries'
      variant='contained'
      className={classes.exportButton}
      onClick={handleExportClick}
      disabled={isButtonDisabled}
      startIcon={<CloudDownload />}
    >
      <Typography className={classes.exportButtonText}>
        {t('Export')}
      </Typography>
    </Button>
  )

  return (
    !isButtonDisabled ? (
      exportButton
    ) : (
      <Tooltip
        title={t('No Modified Entries')}
        placement={'top'}
        style={{ pointerEvents: 'auto' }}
        arrow
      >
        {exportButton}
      </Tooltip>
    )
  )
}

export default ExportModifiedEntries
